import { render, staticRenderFns } from "./DemographicQuestionsForm.vue?vue&type=template&id=4889dfa1&"
import script from "./DemographicQuestionsForm.vue?vue&type=script&lang=ts&"
export * from "./DemographicQuestionsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports